$checkbox-height: 16px
$duration: 0.4s

\:host
    position: relative

.CheckboxContainer
    display: flex
    flex-direction: row
    align-items: center
    font-size: 14px
    padding: 5px 10px
    -webkit-user-select: none
    -moz-user-select: none
    -ms-user-select: none
    user-select: none
    cursor: pointer
    color: rgb($globalSettingsFontSecondary)
    box-sizing: border-box
    &:hover
        color: rgb($globalSettingsFontPrimary)

.Terms
    font-size: 12px

.CheckboxContainer:hover input ~ .CheckboxField
    border: $checkbox-height * .1 solid rgb($globalSettingsStrokePrimary)

//Disabled
.CheckboxContainer input:disabled ~ .CheckboxField
    border: $checkbox-height * .1 solid rgb($globalSettingsStrokeSecondary)
    cursor: default
.CheckboxContainer:hover input:disabled ~ .CheckboxField
    border: $checkbox-height * .1 solid rgb($globalSettingsStrokeSecondary)

.CheckboxField
    height: $checkbox-height
    width: $checkbox-height
    background-color: transparent
    border: $checkbox-height * .1 solid rgb($globalSettingsStrokeSecondary)
    border-radius: $globalButtonRounding
    position: relative
    display: inline-block
    -moz-box-sizing: border-box
    -webkit-box-sizing: border-box
    box-sizing: border-box
    cursor: pointer
    flex-shrink: 0
    &::before, &::after
        -moz-box-sizing: border-box
        -webkit-box-sizing: border-box
        box-sizing: border-box
        position: absolute
        height: 0
        width: $checkbox-height * .2
        background-color: rgb($globalButtonBackgroundPrimary)
        display: inline-block
        transform-origin: left top
        border-radius: $globalButtonRounding
        content: ' '

    &::before
        top: $checkbox-height * .72
        left: $checkbox-height * .41
        box-shadow: 0 0 0 $checkbox-height * 0.05 rgba($globalSettingsBackgroundShadowColor,0.05)
        transform: rotate(-135deg)

    &::after
        top: $checkbox-height * .37
        left: $checkbox-height * .05
        transform: rotate(-45deg)

.Selected
    font-weight: 700

// Errors
.ContainerError
    border: 2px rgb($globalErrorBackground) solid
    background-color: rgb($globalSettingsBackgroundSecondary)
    border-radius: $globalSettingsRounding

.ContainerError input ~ .CheckboxField
    border: $checkbox-height * .1 solid rgb($globalErrorBackground)

.CheckboxContainer input ~ .Error
    border: $checkbox-height * .1 solid rgb($globalErrorBackground) !important

.Label
    margin-left: 10px
    cursor: pointer

input[type=checkbox]
    display: none

input[type=checkbox]:checked + .CheckboxField
    &.checked
        border-color: rgb($globalButtonBackgroundPrimary)

    &::after
        height: $checkbox-height*0.5
        -moz-animation: bottomCheck $duration/2 ease 0s forwards
        -o-animation: bottomCheck $duration/2 ease 0s forwards
        -webkit-animation: bottomCheck $duration/2 ease 0s forwards
        animation: bottomCheck $duration/2 ease 0s forwards

    &::before
        height: $checkbox-height * 1.2
        -moz-animation: topCheck $duration ease 0s forwards
        -o-animation: topCheck $duration ease 0s forwards
        -webkit-animation: topCheck $duration ease 0s forwards
        animation: topCheck $duration ease 0s forwards

@-moz-keyframes bottomCheck
    0%
        height: 0
    100%
        height: $checkbox-height/2

@-webkit-keyframes bottomCheck
    0%
        height: 0
    100%
        height: $checkbox-height/2

@keyframes bottomCheck
    0%
        height: 0
    100%
        height: $checkbox-height/2

@keyframes topCheck
    0%
        height: 0
    50%
        height: 0
    100%
        height: $checkbox-height * 1.2

@-webkit-keyframes topCheck
    0%
        height: 0
    50%
        height: 0
    100%
        height: $checkbox-height * 1.2

@-moz-keyframes topCheck
    0%
        height: 0
    50%
        height: 0
    100%
        height: $checkbox-height * 1.2


/*--- fixed style ---*/
.CheckboxContainerFixedStyle
    display: flex
    flex-direction: row
    align-items: center
    font-size: 14px
    -webkit-user-select: none
    -moz-user-select: none
    -ms-user-select: none
    user-select: none
    cursor: pointer
    color: rgb(97, 95, 115)
    &:hover
        color: rgb(70, 70, 91)

.CheckboxContainerFixedStyle:hover input ~ .CheckboxFieldFixedStyle
    border: $checkbox-height * .1 solid rgb(208, 208, 214)

//Disabled
.CheckboxContainerFixedStyle input:disabled ~ .CheckboxFieldFixedStyle
    border: $checkbox-height * .1 solid rgb(215, 215, 220)
    cursor: default
.CheckboxContainerFixedStyle:hover input:disabled ~ .CheckboxFieldFixedStyle
    border: $checkbox-height * .1 solid rgb(215, 215, 220)

.CheckboxFieldFixedStyle
    height: $checkbox-height
    width: $checkbox-height
    background-color: transparent
    border: $checkbox-height * .1 solid rgb(215, 215, 220)
    border-radius: 5px
    position: relative
    display: inline-block
    -moz-box-sizing: border-box
    -webkit-box-sizing: border-box
    box-sizing: border-box
    cursor: pointer
    flex-shrink: 0
    &::before, &::after
        -moz-box-sizing: border-box
        -webkit-box-sizing: border-box
        box-sizing: border-box
        position: absolute
        height: 0
        width: $checkbox-height * .2
        background-color: rgb(42, 173, 186)
        display: inline-block
        transform-origin: left top
        border-radius: 5px
        content: ' '
    &::before
        top: $checkbox-height * .72
        left: $checkbox-height * .41
        box-shadow: 0 0 0 $checkbox-height * 0.05 rgb(235, 235, 235)
        transform: rotate(-135deg)

    &::after
        top: $checkbox-height * .37
        left: $checkbox-height * .05
        transform: rotate(-45deg)

input[type=checkbox]:checked + .CheckboxFieldFixedStyle
    &.checked
        border-color: rgb(42, 173, 186)

    &::after
        height: $checkbox-height * 0.5
        -moz-animation: bottomCheck $duration/2 ease 0s forwards
        -o-animation: bottomCheck $duration/2 ease 0s forwards
        -webkit-animation: bottomCheck $duration/2 ease 0s forwards
        animation: bottomCheck $duration/2 ease 0s forwards

    &::before
        height: $checkbox-height * 1.2
        -moz-animation: topCheck $duration ease 0s forwards
        -o-animation: topCheck $duration ease 0s forwards
        -webkit-animation: topCheck $duration ease 0s forwards
        animation: topCheck $duration ease 0s forwards
